export {}

import loadGoogleMaps from "js/google-maps/google-maps"

interface BranchInfoMapSettings {
  key: string
  map_id: string
}

let map: google.maps.Map
const gMarkers: google.maps.marker.AdvancedMarkerElement[] = []

const mapElement = document.getElementById("branch-info-map")
const mapLat = mapElement?.dataset.lat
const mapLng = mapElement?.dataset.lng
const icon = mapElement?.dataset.icon ?? null

const mapSettings: BranchInfoMapSettings = JSON.parse(mapElement?.getAttribute("data-map") ?? "")

const initMap = async () => {
  if (mapElement && mapLat && mapLng) {
    const google = await loadGoogleMaps()
    const {AdvancedMarkerElement} = (await google.maps.importLibrary("marker")) as google.maps.MarkerLibrary

    map = new google.maps.Map(mapElement, {
      mapId: mapSettings.map_id,
      center: {lat: Number(mapLat), lng: Number(mapLng)},
      zoom: 17,
    })

    const marker = new AdvancedMarkerElement({
      map: map,
      position: {lat: Number(mapLat), lng: Number(mapLng)},
      content: icon ? setIcon(icon) : null,
    })

    gMarkers.push(marker)
  }
}

initMap()

const setIcon = (iconSrc: string) => {
  const markerSvg = document.createElement("img")
  markerSvg.src = iconSrc

  return markerSvg
}
